// @flow

// account-company
export const SET_COMPANY_INFO = "SET_COMPANY_INFO";
export const UPDATE_COMPANY_LICENCE = "UPDATE_COMPANY_LICENCE";
export const UPDATE_COMPANY_CHILD = "UPDATE_COMPANY_CHILD";
export const UPDATE_COMPANY_FACEBASE = "UPDATE_COMPANY_FACEBASE";
export const UPDATE_COMPANY_USER = "UPDATE_COMPANY_USER";
export const UPDATE_LICENCET_ITEM = "UPDATE_LICENCET_ITEM";
export const REMOVE_COMPANY_LICENCE = "REMOVE_COMPANY_LICENCE";
export const EDIT_COMPANY_FACEBASE = "EDIT_COMPANY_FACEBASE";
export const REMOVE_COMPANY_USER = "REMOVE_COMPANY_USER";

//account-licence
export const SET_COMPANY_GROUP_LICENCES = "SET_COMPANY_GROUP_LICENCES";

export const SET_LICENCE_EMAIL_NOTIFICATION = "SET_LICENCE_EMAIL_NOTIFICATION";
export const UPDATE_LICENCE_EMAIL_NOTIFICATION = "UPDATE_LICENCE_EMAIL_NOTIFICATION";
export const PATCH_LICENCE_EMAIL_NOTIFICATION = "PATCH_LICENCE_EMAIL_NOTIFICATION";
export const REMOVE_LICENCE_EMAIL_NOTIFICATION = "REMOVE_LICENCE_EMAIL_NOTIFICATION";
export const CLEAR_LICENCE_EMAIL_NOTIFICATION = "CLEAR_LICENCE_EMAIL_NOTIFICATION";

// account-face
export const SAVE_TOKEN = "SAVE_TOKEN_V3";
export const DETECT_IMAGE = "DETECT_IMAGE_V3";
export const SET_CANVAS_STATE_FACES = "SET_CANVAS_STATE_FACES_V3";
export const SET_LOADED_IMAGE = "SET_LOADED_IMAGE_V3";

export const ADD_IMAGE_TO_FACE_SEARCH = "ADD_IMAGE_TO_FACE_SEARCH_V3";
export const SEARCH_BY_FACE = "SEARCH_BY_FACE_V3";
export const SET_SEARCHED_PERSON = "SET_SEARCHED_PERSON_V3";
export const SET_CURRENT_FACE = "SET_CURRENT_FACE_V3";

// action-people
export const LIST_PEOPLE = "LIST_PEOPLE_V3";
export const GET_ALL_TAGS = "GET_ALL_TAGS_V3";

export const GET_FACE = "GET_FACE_v3";
export const SET_UPDATING = "SET_UPDATING_v3";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY_V3";
export const SET_SHOWMORE_STATUS = "SET_SHOWMORE_STATUS_V3";
export const SET_FACE = "SET_FACE_V3";
export const SET_EMPTY_ENROLMENTS = "SET_EMPTY_ENROLMENTS_V3";
export const SET_NAME = "SET_NAME_V3";
export const SET_TAGS = "SET_TAGS_V3";
export const DELETE_PERSON = "DELETE_PERSON_V3";
export const ADD_PERSON = "ADD_PERSON_V3";
export const SET_PEOPLE_FORM_ERROR = "SET_PEOPLE_FORM_ERROR_V3";

// account-project
export const SET_RESELLER_TREE = "SET_RESELLER_TREE";
export const UPDATE_PROJECT_LIST = "UPDATE_PROJECT_LIST";
export const GET_CLOSESTATUS_LIST = "GET_CLOSESTATUS_LIST";
export const PROJECT_ENDUSER_LIST = "PROJECT_ENDUSER_LIST";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const SET_DISTRIBUTER_TREE = "SET_DISTRIBUTER_TREE";

// account-quote
export const SET_PRICE_SHEET = "SET_PRICE_SHEET";
export const UPDATE_QUOTE_LIST = "UPDATE_QUOTE_LIST";
export const GET_QUOTE_COMPANY_LIST = "GET_QUOTE_COMPANY_LIST";
export const GET_PRODUCT_SHEET = "GET_PRODUCT_SHEET";
export const GET_QUOTE_LIST = "GET_QUOTE_LIST";
export const GET_QUOTE_LICENCES = "GET_QUOTE_LICENCES";

// account-software
export const GET_SOFTWARE_LIST = "GET_SOFTWARE_LIST";
export const UPDATE_SOFTWARE_ITEM = "UPDATE_SOFTWARE_ITEM";
export const GET_SOFTWARE_COMPANIES = "GET_SOFTWARE_COMPANIES";
export const GET_SOFTWARE_USERS = "GET_SOFTWARE_USERS";

// account-user
export const SET_AUTH = "SET_AUTH";
export const SET_LOGINS = "SET_LOGINS";
export const SET_FETCHING_AUTH = "SET_FETCHING_AUTH";
export const SET_USER_GRAPHQL = "SET_USER_GRAPHQL";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_LICENCE = "UPDATE_USER_LICENCE";
export const ADD_TAB = "ADD_TAB";
export const SET_STEP = "SET_STEP";

// account-billing
export const GET_BILLING_COMPANY = "GET_BILLING_COMPANY";
export const GET_CURRENT_BILLING = "GET_CURRENT_BILLING";
export const GET_HISTORY_BILLINGS = "GET_HISTORY_BILLINGS";
export const GET_HISTORY_BILLING_DETAIL = "GET_HISTORY_BILLING_DETAIL";

// admin-company
export const ADMIN_GET_COMPANY_LIST = "ADMIN_GET_COMPANY_LIST";
export const ADMIN_UPDATE_COMPANY_LIST = "ADMIN_UPDATE_COMPANY_LIST";
export const ADMIN_UPDATE_COMPANY_LICENCE = "ADMIN_UPDATE_COMPANY_LICENCE";
export const ADMIN_UPDATE_COMPANY_FACEBASE = "ADMIN_UPDATE_COMPANY_FACEBASE";
export const ADMIN_UPDATE_COMPANY_USER = "ADMIN_UPDATE_COMPANY_USER";
export const ADMIN_UPDATE_COMPANY_CHILD = "ADMIN_UPDATE_COMPANY_CHILD";
export const ADMIN_UPDATE_TIER = "ADMIN_UPDATE_TIER";
export const ADMIN_EDIT_COMPANY_FACEBASE = "ADMIN_EDIT_COMPANY_FACEBASE";
export const ADMIN_REMOVE_USER_FROM_COMPANY = "ADMIN_REMOVE_USER_FROM_COMPANY";
export const ADMIN_DELETE_LICENCE_FROM_COMPANY =
  "ADMIN_DELETE_LICENCE_FROM_COMPANY";
export const ADMIN_REMOVE_COMPANY_ITEM = "ADMIN_REMOVE_COMPANY_ITEM";
export const ADMIN_UPDATE_LICENCE_LIST = "ADMIN_UPDATE_LICENCE_LIST";
export const ADMIN_UPDATE_PRODUCT_TIER = "ADMIN_UPDATE_PRODUCT_TIER";

// admin-facebase
export const ADMIN_SET_FACEBASE_LIST = "ADMIN_SET_FACEBASE_LIST";
export const ADMIN_ADD_FACEBASE = "ADMIN_ADD_FACEBASE";
export const ADMIN_UPDATE_FACEBASE = "ADMIN_UPDATE_FACEBASE";
export const ADMIN_REMOVE_USER_FROM_FACEBASE =
  "ADMIN_REMOVE_USER_FROM_FACEBASE";
export const ADMIN_REMOVE_LICENCE_FROM_FACEBASE =
  "ADMIN_REMOVE_LICENCE_FROM_FACEBASE";
export const ADMIN_DELETE_FACEBASE = "ADMIN_DELETE_FACEBASE";
export const ADMIN_UPDATE_FACEBASE_USER = "ADMIN_UPDATE_FACEBASE_USER";

// admin-licence
export const ADMIN_GET_LICENCE_LIST = "ADMIN_GET_LICENCE_LIST";
export const ADMIN_UPDATE_LICENCE_ITEM = "ADMIN_UPDATE_LICENCE_ITEM";
export const ADMIN_DELETE_LICENCE_ITEM = "ADMIN_DELETE_LICENCE_ITEM";
export const ADMIN_LICENCE_UPDATE_ITEM = "ADMIN_LICENCE_UPDATE_ITEM";

// admin-project
export const ADMIN_UPDATE_PROJECT_LIST = "ADMIN_UPDATE_PROJECT_LIST";
export const ADMIN_SET_RESELLER_TREE = "ADMIN_SET_RESELLER_TREE";
export const ADMIN_DELETE_PROJECT_LIST = "ADMIN_DELETE_PROJECT_LIST";
export const ADMIN_PROJECT_ENDUSER_LIST = "ADMIN_PROJECT_ENDUSER_LIST";
export const ADMIN_GET_PROJECT_LIST = "ADMIN_GET_PROJECT_LIST";

// admin-quote
export const ADMIN_UPDATE_QUOTE_LIST = "ADMIN_UPDATE_QUOTE_LIST";
export const ADMIN_DELETE_QUOTE_ITEM = "ADMIN_DELETE_QUOTE_ITEM";
export const ADMIN_GET_QUOTE_COMPANY_LIST = "ADMIN_GET_QUOTE_COMPANY_LIST";
export const ADMIN_UPDATE_PRODUCT_SHEET_LIST =
  "ADMIN_UPDATE_PRODUCT_SHEET_LIST";
export const ADMIN_GET_SHEET_COMPANY_LIST = "ADMIN_GET_SHEET_COMPANY_LIST";
export const ADMIN_GET_QUOTE_LIST = "ADMIN_GET_QUOTE_LIST";

// admin-reseller
export const ADMIN_UPDATE_RESELLER_LIST = "ADMIN_UPDATE_RESELLER_LIST";
export const ADMIN_UPDATE_RESELLER_DETAIL = "ADMIN_UPDATE_RESELLER_DETAIL";

// admin-user
export const ADMIN_GET_ALL_USERS = "ADMIN_GET_ALL_USERS";
export const ADMIN_REMOVE_USER_ITEM = "ADMIN_REMOVE_USER_ITEM";
export const ADMIN_GET_ALL_GROUPS = "ADMIN_GET_ALL_GROUPS";
export const ADMIN_APPEND_USER_DATA = "ADMIN_APPEND_USER_DATA";
export const ADMIN_GET_COMPANY_FACEBASE = "ADMIN_GET_COMPANY_FACEBASE";
export const ADMIN_UPDATE_USER_LIST = "ADMIN_UPDATE_USER_LIST";
export const ADMIN_GET_GROUP_USERS = "ADMIN_GET_GROUP_USERS";

// admin-billing
export const GET_ALL_BILLING_COMPANY = "GET_ALL_BILLING_COMPANY";
export const ADMIN_GET_CURRENT_BILLING = "GET_COMPANY_CURRENT_BILLING";
export const ADMIN_GET_HISTORY_BILLING = "ADMIN_GET_HISTORY_BILLING";
export const ADMIN_GET_HISTORY_BILLING_DETAIL =
  "ADMIN_GET_HISTORY_BILLING_DETAIL";
export const GET_ALL_BILLING_PARTS = "GET_ALL_BILLING_PARTS";
export const ADMIN_GET_COMPANY_PRICES = "ADMIN_GET_COMPANY_PRICES";
export const ADMIN_UPDATE_COMPANY_PRICE = "ADMIN_UPDATE_COMPANY_PRICE";
export const ADMIN_UPLOAD_INVOICE_FILE = "ADMIN_UPLOAD_INVOICE_FILE";
